import { mkTrackAttrs } from '@/analytics/track';
import { ThreadId } from '@/models/Thread';

const PREFIX = `thread_bar` as const;

// About Button
export const mkAboutBtnTrackAttrs = (props: {} = {}) =>
  mkTrackAttrs(`${PREFIX}__about_btn`, props);

// Bug Report Button
export const mkBugReportBtnTrackAttrs = (props: {} = {}) =>
  mkTrackAttrs(`${PREFIX}__bug_report_btn`, props);

// Collapse Button
export const mkCollapseBtnTrackAttrs = (props: {} = {}) =>
  mkTrackAttrs(`${PREFIX}__collapse_btn`, props);

// Expand Button
export const mkExpandBtnTrackAttrs = (props: {} = {}) =>
  mkTrackAttrs(`${PREFIX}__expand_btn`, props);

// New Thread Button
export const mkNewThreadBtnTrackAttrs = (props: {} = {}) =>
  mkTrackAttrs(`${PREFIX}__new_thread_btn`, props);

// Thread Link
export const mkThreadLinkTrackAttrs = (props: {
  threadId: ThreadId;
  threadIndex: number;
  renderedThreadCount: number;
}) => mkTrackAttrs(`${PREFIX}__thread_link`, props);

// Login Button
export const mkLoginBtnTrackAttrs = (props: {} = {}) =>
  mkTrackAttrs(`${PREFIX}__login_btn`, props);

// Logout Button
export const mkLogoutBtnTrackAttrs = (props: {} = {}) =>
  mkTrackAttrs(`${PREFIX}__logout_btn`, props);

// View Threads Button
export const mkViewThreadsBtnTrackAttrs = (props: {} = {}) =>
  mkTrackAttrs(`${PREFIX}__view_threads_btn`, props);
